import { addDays, addHours, differenceInMinutes, startOfDay } from "date-fns";
import {
  UTCDateTimeToTimezone,
  getTimezoneOffsetMillis,
} from "../../../common/dateHelpers";

const getDeadlineMinutes = ({
  timezone,
  startedAtCenterTimezone,
  readyToReadAtCenterTimezone,
  reportDeliveryDeadlineHours,
  isStat,
}: {
  timezone: string;
  startedAtCenterTimezone: Date;
  readyToReadAtCenterTimezone: Date;
  reportDeliveryDeadlineHours: number;
  isStat: boolean;
}): number => {
  const now = new Date();
  const utcNow = new Date(now.getTime() + now.getTimezoneOffset() * 60000);
  const nowCenterTimeZone = UTCDateTimeToTimezone(
    utcNow,
    getTimezoneOffsetMillis(timezone),
  );

  const deadline = isStat
    ? startOfDay(addDays(startedAtCenterTimezone, 1))
    : addHours(readyToReadAtCenterTimezone, reportDeliveryDeadlineHours);

  return differenceInMinutes(deadline, nowCenterTimeZone);
};

export default getDeadlineMinutes;
